import equals from 'ramda/src/equals'

import { projectPendingKey } from 'root/src/shared/constants/keys'
import statusSelector from 'root/src/client/logic/project/selectors/statusSelector'
import isAdminSelector from 'root/src/client/logic/auth/selectors/isAdminSelector'

export default (state, props) => equals(statusSelector(state, props), projectPendingKey)
	&& isAdminSelector(state, props)
